import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * A non-visual component for the EdgelessElementGroupsBlockModel.
 * This block manages state but doesn't render anything itself.
 */
@customElement('pique-edgeless-element-tab')
export class EdgelessElementGroupsBlockComponent extends LitElement {
  override render() {
    // This block has no visual representation
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pique-edgeless-element-tab': EdgelessElementGroupsBlockComponent;
  }
}
